import { object, string, ZodIssueCode } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { MessagingCampaignTargetFormInitialValues } from './target-form.types';

export const TargetFormSchema = object({
  inAudience: object({
    audience: object({
      uuid: string().optional(),
    })
      .optional()
      .nullable(),
  })
    .optional()
    .superRefine((value, ctx) => {
      if (!value?.audience?.uuid) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: IS_REQUIRED,
          path: ['audience'],
        });
      }
    }),
});

export const validateTargetSync = (values: MessagingCampaignTargetFormInitialValues) =>
  TargetFormSchema.safeParse(values);
